import * as React from 'react';
import {connect} from 'react-redux';

import classnames from 'classnames';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';

import {setActiveItem, newActiveItem} from '../../ui-actions';

import styles from './sales-automation-card.module.css';

// @ts-expect-error
const mapDispatchToProps = function (dispatch, ownProps: OwnProps): DispatchProps {
    return {
        onCardClick: () => {
            const {parentId, type, entityId} = ownProps;
            if (entityId) {
                dispatch(setActiveItem({parentId, type, entityId}));
            } else {
                dispatch(newActiveItem(parentId, type));
            }
        },
    };
};

type OwnProps = {
    parentId: string;
    type: SalesAutomationItemType;
    isHidden?: boolean;
    clearFocusAfterClick?: boolean;
    entityId?: string;
    children?: React.ReactNode;
    draggableProps?: any;
    dragHandleProps?: any;
    getDraggableRef?: (...args: any) => any;
    borderColor?: string;
};

type DispatchProps = {
    onCardClick: () => void;
};

type Props = OwnProps & DispatchProps;

/*
 * Root component for any item currently applied to a sales process.
 *
 * This defers to the individual types' components for the actual rendering
 * of the cards.
 */
export class SalesAutomationCardComponent extends React.PureComponent<Props> {
    button: HTMLElement | null | undefined;

    render() {
        let styleName = styles.card;
        const isCreateCard = !this.props.entityId;

        if (isCreateCard) styleName = styles['card--create'];

        if (this.props.isHidden) styleName = styles['card--hidden'];

        return (
            <button
                style={{
                    borderTop: this.props.borderColor
                        ? `1px solid ${this.props.borderColor}`
                        : 'none',
                }}
                type='button'
                id={this.props.type === 'userAssignments' ? 'user-assignment-button' : ''}
                ref={this.setRef}
                {...this.props.draggableProps}
                {...this.props.dragHandleProps}
                // Our onClick event needs to be below the dragHandleProps spread
                onClick={this.handleClick}
                className={classnames(
                    styleName,
                    this.props.draggableProps?.className,
                    this.props.dragHandleProps?.className
                )}
            >
                {this.props.children}
            </button>
        );
    }

    setRef = (node: HTMLElement) => {
        this.button = node;
        if (typeof this.props.getDraggableRef === 'function') {
            this.props.getDraggableRef(node);
        }
    };

    handleClick = () => {
        if (this.props.clearFocusAfterClick && this.button) {
            this.button.blur();
        }

        this.props.onCardClick();
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(undefined, mapDispatchToProps);
export const SalesAutomationCard = connector(SalesAutomationCardComponent);
